<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">
        Данные о компании
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2"  step="2">
        Обработка
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3">
        Заключение договора
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 4" step="4">
        Подготовка
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="5">
        Старт операций
      </v-stepper-step>


    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1" style="max-width: 1200px">
        <!--        <v-card class="mb-12" >-->
        <p class="text-h6">Благодарим за регистрацию</p>

        <div v-if="this.offer.fileName!==undefined">
          <p>
            Если Вас устроили <a @click="downloadOffer">предложенные тарифы</a>, для начала работы необходимо подписать форму договора Эй-Пи Трейд.<br>
            Мы сами заполним договор и пришлём его Вам уже подписанным с нашей стороны.<br>
            Вам просто нужно загрузить все необходимые документы, заверенные печатью Вашей организации.<br>
            Предоставление полного пакета документов и реквизитов существенно ускорит подписание договора.<br>
          </p>
          <v-form>
            <v-file-input

                label="Реквизиты компании"
                v-model="requisitesFile"
            ></v-file-input>

            <custom-field-description html-description='Карточка компании с указанием регистрационных данны (ИНН, КПП и т.д), банковских реквизитов, общей информаци  (название, форма собственности), контактной информации. Пустой бланк можно скачать <a href="/static/requisites.xls" target="_blank">тут</a>.'/>

            <v-file-input
                label="Устав или паспорт"
                messages="Для юридических лиц необходимо приложить устав, а для индивидуальных предпренимателей копию паспорта"
                v-model="charterFile"
            ></v-file-input>

            <v-file-input
                label="Свидетельство ИНН. Для Юридических лиц и Индивидуальных Предпринимателей"
                v-model="innFile"
            ></v-file-input>
            <custom-field-description html-description='С примером ИНН можно ознакомится по <a href="/static/inn.png" target="_blank">ссылке</a>'/>

            <v-file-input
                label="Выписка из ЕГРЮЛ или ЕГРИП"
                v-model="egrulFile"
            ></v-file-input>
            <custom-field-description html-description='Для Юридических лиц - <a href="/static/egrul.png" target="_blank">ЕГРЮЛ</a>, для Индивидуальных предпринимателей - <a href="/static/egrip.png" target="_blank">ЕГРИП</a>. В бумажном (с голубой печатью и подписью должностного лица налоговой службы)  или электронном (подписанай усиленной квалифицированной электронной подписью) виде. Выданная, не ранее, чем за 3 месяца до момента предоставления'/>

            <!--          <p class="mt-n6 ml-8 caption">тут описание того что нужно вложить...</p>-->

            <v-file-input
                label="Документ подтверждающий полномочия"
                messages="Для Юридических лиц: копия протокол заседания собрания акционеров, собрания участников, собрания учредителей, совета директоров или наблюдательного совета об избрании директора; копия приказ о вступлении в должность директора (при наличии); Доверенность на имя подписанта, выданная директором (если договор подписывает не директор). Для Индивидуальных Предпринимателей: копия паспорта или доверенность (если договор подписывает не сам Предприниматель)"
                v-model="confirmingFile"
            ></v-file-input>
            <!--          <p class="mt-n6 ml-8 caption">тут описание того что нужно вложить...</p>-->

          </v-form>

          <v-btn color="primary" @click="sendDocs" :disabled="btnNextDisabled" class="mt-3">
            Далее
          </v-btn>
          <span class="ml-4 mt-6" v-if="btnNextDisabled">{{btnNextDisabledDescription}}</span>
        </div>
        <div v-else>
          <p>Для заключения договора пожалуйста <a href="https://ap-logistics.ru/?anketa=true">заполните анкету</a>.</p>
          <p>На основании полученной анкеты мы пришлем вам коммерческое предложение которое будет основанием для запуска процесса заключения договора.</p>
        </div>

      </v-stepper-content>

      <v-stepper-content step="2">
        <div class="text-center">
          <v-icon large color="blue lighten-2" class="mt-3">
            mdi-timer-sand
          </v-icon>
          <p class="mb-3 mt-3">
            Благодарим за предоставленную информацию.<br>
            В течении одного рабочего дня мы ее обработаем<br>
            и пришлем договор для подписания.
          </p>
        </div>
<!--        <v-btn color="primary" @click="e1 = 3">-->
<!--          Далее-->
<!--        </v-btn>-->

      </v-stepper-content>

      <v-stepper-content step="3" style="max-width: 1200px">

        <p>
          1. Пожалуйста скачайте договор <v-btn text color="primary" @click="downloadContract" >{{this.contract.fileName}}</v-btn>
        </p>
        <p>
          2. Распечатайте, подпишите, заверьте синей печатью Вашей организации, сделайте скан-копию
        </p>

        <p>
          3. Вложите скан копию
          <v-file-input
              label="Подписанный договор"
              v-model="contractFile"
          ></v-file-input>
        </p>


        <v-btn color="primary" @click="sendContract" :disabled="btnSendContractDisabled">
          Далее
        </v-btn>
        <span class="ml-4 mt-6" v-if="btnSendContractDisabled">
          Для того чтобы перейти к следующему шагу пожалуйста вложите подписанный с вашей стороны договор.
        </span>

      </v-stepper-content>

      <v-stepper-content step="4">
        <div class="text-center">
          <v-icon large color="blue lighten-2" class="mt-3">
            mdi-timer-sand
          </v-icon>
          <p class="mb-3 mt-3">
            Благодарим за предоставленные данные.<br>
            Мы подготавливаем наши учетные системы для работаты с вами.<br>
            В течении одного рабочего дня мы пришлем вам уведоление о старте операций.
          </p>


        </div>

<!--        <v-btn color="primary" @click="e1 = 5">-->
<!--          Далее-->
<!--        </v-btn>-->

      </v-stepper-content>

      <v-stepper-content step="5">
<!--        <p class="text-h6">Все готово</p>-->
        <p>
          Уважаемый Клиент, благодарим Вас за выбор нашей компании в качестве поставщика логистических услуг.<br/>
          Перед началом работы предлагаем ознакомиться с <a @click="openNotes">памяткой</a>.

        </p>


        <v-btn color="primary" @click="startOperation">
          Начать работу
        </v-btn>

      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>


</template>

<script>
// import { mapGetters, mapActions, mapMutations } from "vuex"
import {mapActions, mapGetters} from "vuex"
import {fileToBase64} from "@/domain/utils";
import {backendPostRequest} from "@/domain/backend.api";
import CustomFieldDescription from "@/components/CustomFieldDescription.vue";
export default {
  name: "StartWizard",
  components:{CustomFieldDescription},
  data() {
    return {
      contract: {fileName: undefined},
      offer: {fileName: undefined},

      requisitesFile: undefined,
      charterFile: undefined,
      innFile:undefined,
      egrulFile: undefined,
      confirmingFile: undefined,

      contractFile: undefined,

      e1: 1,

    }
  },
  methods: {
    ...mapActions("app", ["apiNewTicket","apiGetFile"]),

    startOperation(){
      localStorage.setItem('operation','started')
      location.reload();
    },

    async openNotes(){
      //https://subtitletools.com/convert-text-files-to-utf8-online
      const result = await this.appRefs.DialogInfoWeb.show({
        title: "Памятка по работе в личном кабинете",
        src: `/static/Памятка%20о%20порядке%20работы.htm`,
        positiveTitle: "Ознакомился",
      });
      console.log(result)

    },

    async sendDocs(){
      let files = []
      if (this.requisitesFile!==undefined){
        files.push(
            {
              type: "Реквизиты компании",
              fileName: this.requisitesFile.name,
              base64: await fileToBase64(this.requisitesFile)
            }
        )
      }
      if (this.charterFile!==undefined){
        files.push(
            {
              type: "Устав",
              fileName: this.charterFile.name,
              base64: await fileToBase64(this.charterFile)
            }
        )
      }
      if (this.innFile!==undefined){
        files.push(
            {
              type: "ИНН",
              fileName: this.innFile.name,
              base64: await fileToBase64(this.innFile)
            }
        )
      }
      if (this.egrulFile!==undefined){
        files.push(
            {
              type: "Выписка из ЕГРЮЛ",
              fileName: this.egrulFile.name,
              base64: await fileToBase64(this.egrulFile)
            }
        )
      }
      if (this.confirmingFile!==undefined){
        files.push(
            {
              type: "Документ подтверждающий полномочия",
              fileName: this.confirmingFile.name,
              base64: await fileToBase64(this.confirmingFile)
            }
        )
      }



      if (files.length>0) {
        await this.apiNewTicket({
          ticketType: "УчредительныеДокументы",
          location: "",
          comment: "",
          files: files
        });
      }


      this.e1 = 2
    },

    async getContract(){
      this.contract = await backendPostRequest("api", {
        command: "getContract"
      })

      console.log('getContract()', this.contract)
    },

    async getOffer(){
      this.offer = await backendPostRequest("api", {
        command: "getOffer"
      })
      console.log('offer', this.offer);
    },

    async sendContract(){
      this.e1 = 4
      if (this.contractFile!==undefined){
        const result = await this.apiNewTicket({
          ticketType: "Договор",
          location: "",
          comment: "",
          files: [
            {
              type: "Договор",
              fileName: this.contractFile.name,
              base64: await fileToBase64(this.contractFile)
            }
          ]
        });
        console.log('apiNewTicket: Договор',result)

      }

    },

    async downloadContract(){
      await this.apiGetFile({fileGUID: this.contract.fileGUID, fileMetatype: this.contract.fileMetatype})
    },

    async downloadOffer(){
      console.log('click offer')
      await this.apiGetFile({fileGUID: this.offer.fileGUID, fileMetatype: this.offer.fileMetatype})
    },


  },
  watch: {
    charterFile(val){
      console.log('charterFile', val)
    },
    getStep(step){
      console.log('step', step)
      this.e1 = step;
    }
    // getWorkStatus(val){
    //   console.log('getWorkStatus',val)
    //   this.e1 = val.status;
    // },
  },
  computed: {
    ...mapGetters('app',[
      "getWorkStatus",
    ]),
    getStep(){
      const workStatus = this.$store.getters["app/getWorkStatus"];
      return workStatus.status;
    },
    btnSendContractDisabled(){
      if (this.contractFile){
        return false;
      }
      return true;
    },
    btnNextDisabledDescription(){
      // let countRequired = 0;
      let description = "Для перехода на следующий шаг необходимо приложить: "

      if (!this.charterFile){ description+='устав или паспорт, ';}
      if (!this.innFile){ description+='ИНН, ';}
      if (!this.egrulFile){ description+='ЕГРЮЛ или ЕГРИП, ';}

      description = description.substring(0, description.length - 2) + '.'

      return description
    },
    btnNextDisabled(){
      let countRequired = 0;
      if (!this.charterFile){ countRequired++;}
      if (!this.innFile){ countRequired++;}
      if (!this.egrulFile){ countRequired++;}

      if ( countRequired > 0 ) return true;
      return false;
    },
    getclientStatus(){
      return 1
    }
  },
  created() {
    this.getContract();
    this.getOffer();
  },
  mounted(){
    this.e1 = this.getWorkStatus.status;
  },

  inject:['appRefs']

}
</script>
